<template>
<div class="chapter">
<div class="inner_page">
<div id="Contents.html" xml:lang="en-US">
<div class="Basic-Text-Frame-5">
<p class="TOCtitle">Contents</p>
<p class="TOCitem"><a href="#/Chapter_One#Anchor-1">CHAPTER ONE</a></p>
<p class="TOCitem"><a href="#/Chapter_Two#Anchor-1">CHAPTER TWO</a></p>
<p class="TOCitem"><a href="#/Chapter_Three#Anchor-1">CHAPTER THREE</a></p>
<p class="TOCitem"><span href="#/Chapter_Four#Anchor-1" title="Link target outside of Sample">CHAPTER FOUR</span></p>
<p class="TOCitem"><span href="#/Chapter_Five#Anchor-1" title="Link target outside of Sample">CHAPTER FIVE</span></p>
<p class="TOCitem"><span href="#/Chapter_Six#Anchor-1" title="Link target outside of Sample">CHAPTER SIX</span></p>
<p class="TOCitem"><span href="#/Chapter_Seven#Anchor-1" title="Link target outside of Sample">CHAPTER SEVEN</span></p>
<p class="TOCitem"><span href="#/Chapter_Eight#Anchor-1" title="Link target outside of Sample">CHAPTER EIGHT</span></p>
<p class="TOCitem"><span href="#/Chapter_Nine#Anchor-1" title="Link target outside of Sample">CHAPTER NINE</span></p>
<p class="TOCitem"><span href="#/Chapter_Ten#Anchor-1" title="Link target outside of Sample">CHAPTER TEN</span></p>
<p class="TOCitem"><span href="#/Chapter_Eleven#Anchor-1" title="Link target outside of Sample">CHAPTER ELEVEN</span></p>
<p class="TOCitem"><span href="#/Chapter_Twelve#Anchor-1" title="Link target outside of Sample">CHAPTER TWELVE</span></p>
<p class="TOCitem"><span href="#/Chapter_Thirteen#Anchor-1" title="Link target outside of Sample">CHAPTER THIRTEEN</span></p>
<p class="TOCitem"><span href="#/Chapter_Fourteen#Anchor-1" title="Link target outside of Sample">CHAPTER FOURTEEN</span></p>
<p class="TOCitem"><span href="#/Chapter_Fifteen#Anchor-1" title="Link target outside of Sample">CHAPTER FIFTEEN</span></p>
<p class="TOCitem"><span href="#/Chapter_Sixteen#Anchor-1" title="Link target outside of Sample">CHAPTER SIXTEEN</span></p>
<p class="TOCitem"><span href="#/Chapter_Seventeen#Anchor-1" title="Link target outside of Sample">CHAPTER SEVENTEEN</span></p>
<p class="TOCitem"><span href="#/Chapter_Eighteen#Anchor-1" title="Link target outside of Sample">CHAPTER EIGHTEEN</span></p>
<p class="TOCitem"><span href="#/Chapter_Nineteen#Anchor-1" title="Link target outside of Sample">CHAPTER NINETEEN</span></p>
<p class="TOCitem"><span href="#/Chapter_Twenty#Anchor-1" title="Link target outside of Sample">CHAPTER TWENTY</span></p>
<p class="TOCitem"><span href="#/Chapter_TwentyOne#Anchor-1" title="Link target outside of Sample">CHAPTER TWENTY-ONE</span></p>
<p class="TOCitem"><span href="#/Chapter_TwentyTwo#Anchor-1" title="Link target outside of Sample">CHAPTER TWENTY-TWO</span></p>
<p class="TOCitem"><span href="#/Chapter_TwentyThree#Anchor-1" title="Link target outside of Sample">CHAPTER TWENTY-THREE</span></p>
<p class="TOCitem"><span href="#/Chapter_TwentyFour#Anchor-1" title="Link target outside of Sample">CHAPTER TWENTY-FOUR</span></p>
<p class="TOCitem"><span href="#/Chapter_TwentyFive#Anchor-1" title="Link target outside of Sample">CHAPTER TWENTY-FIVE</span></p>
<p class="TOCitem"><span href="#/Chapter_TwentySix#Anchor-1" title="Link target outside of Sample">CHAPTER TWENTY-SIX</span></p>
<p class="TOCitem"><span href="#/Chapter_TwentySeven#Anchor-1" title="Link target outside of Sample">CHAPTER TWENTY-SEVEN</span></p>
<p class="TOCitem"><span href="#/Chapter_TwentyEight#Anchor-1" title="Link target outside of Sample">CHAPTER TWENTY-EIGHT</span></p>
<p class="TOCitem"><span href="#/Chapter_TwentyNine#Anchor-1" title="Link target outside of Sample">CHAPTER TWENTY-NINE</span></p>
<p class="TOCitem"><span href="#/Chapter_Thirty#Anchor-1" title="Link target outside of Sample">CHAPTER THIRTY</span></p>
<p class="TOCitem"><span href="#/Chapter_ThirtyOne#Anchor-1" title="Link target outside of Sample">CHAPTER THIRTY-ONE</span></p>
<p class="TOCitem"><span href="#/Excerpt#Anchor-1" title="Link target outside of Sample">EXCERPT FROM <em>RETURN TO MARKER RANCH</em> BY CLAIRE McEWEN</span></p>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Contents.vue?13fb2954